import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { updateRiskSchema } from "@backend/src/schemas/riskSchema";

export type RiskApiResponse = ResponseType<null>;
function useUpdateRiskMemberMutation(riskId:string) {
  const mutation = useMutation<
    AxiosResponseAndError<RiskApiResponse>["response"],
    AxiosResponseAndError<RiskApiResponse>["error"],
    z.infer<typeof updateRiskSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.put<RiskApiResponse>(
        requestURLs.risk + riskId,
        data
      ),
  });
  return mutation;
}
export default useUpdateRiskMemberMutation;
